import http from './http';
import store from '../store';
import { getApiRoute } from '../../config';

const getQueryParams = (params) => {
  const parsedParams = [];
  const {
    config: { productId },
  } = store.state[params.productName];

  const cpvUuid = `cpvUuid=${productId}`;
  const uuid = params.requestId ? `uuid=${params.requestId}` : '';
  const barcode = params.barcode ? `id=${params.barcode.toUpperCase()}` : '';

  parsedParams.push(cpvUuid, uuid, barcode);

  return `?${parsedParams.filter((param) => param !== '').join('&')}`;
};
const getNgsQueryParams = (params) => {
  const query = new URLSearchParams();
  if (params.product) query.append('product', params.product);

  return `?${query.toString()}`;
};

const checkNewTicketBarcode = async (barcode, productName) => {
  const { config } = store.getters;
  const response = await http.get(
    `${getApiRoute('baseURL', config)}${getApiRoute('ticketBarcodeCheck', config)}${getQueryParams({ barcode, productName })}`,
  );
  return response.data;
};
const checkNewTicketRequestId = async (requestId, productName) => {
  const config = store.getters.getGameGetter({ specificGame: 'crashcash', getter: 'config' });
  const response = await http.get(
    `${getApiRoute('baseURL', config)}${getApiRoute('ticketRequestIdCheck', config)}${getQueryParams({
      requestId,
      productName,
    })}`,
  );
  return response.data;
};

const checkNGSTicketBarcode = async (barcode, productName) => {
  const config = store.getters.getGameGetter({ getter: 'config' });
  const product = store.state.sevenProductsMapper[productName];
  const { ngsTicketCheck } = store.getters;

  const baseURL = getApiRoute(ngsTicketCheck ? 'ngsURL' : 'baseURL', config);
  const endpoint = getApiRoute(ngsTicketCheck ? 'ngsTicketBarcodeCheck' : 'ticketBarcodeCheck', config);

  const url = ngsTicketCheck
    ? `${baseURL}${endpoint}${barcode.toUpperCase()}${getNgsQueryParams({ product })}`
    : `${baseURL}${endpoint}${barcode.toUpperCase()}.json`;
  const response = await http.get(url);
  return ngsTicketCheck ? response.data.message : response.data;
};

const checkNGSTicketRequestId = async (requestId, productName) => {
  const config = store.getters.getGameGetter({ getter: 'config', specificGame: productName });
  const product = store.state.sevenProductsMapper[productName];
  const { ngsTicketCheck } = store.getters;

  const baseUrl = getApiRoute(ngsTicketCheck ? 'ngsURL' : 'baseURL', config);
  const route = getApiRoute(ngsTicketCheck ? 'ngsTicketRequestIdCheck' : 'ticketRequestIdCheck', config);

  const url = ngsTicketCheck
    ? `${baseUrl}${route}${requestId}${getNgsQueryParams({ product })}`
    : `${baseUrl}${route}${requestId}/product/${product}/check.json`;

  return (await http.get(url)).data;
};

const checkTicketBarcode = async (barcode, ticketType, productName = null) => {
  return ticketType === 'newTicket'
    ? await checkNewTicketBarcode(barcode, productName)
    : await checkNGSTicketBarcode(barcode, productName);
};
const checkTicketRequestId = async (requestId, ticketType, productName) => {
  return ticketType === 'newTicket'
    ? await checkNewTicketRequestId(requestId, productName)
    : await checkNGSTicketRequestId(requestId, productName);
};
export default {
  checkTicketBarcode,
  checkTicketRequestId,
};
